import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class HttpService {
  
  constructor(private http: HttpClient) {
    
  }
  //headerx = new HttpHeaders().set('Content-Type', 'application/json; charset=utf-8');;
  // header = new HttpHeaders().set("X-Frame-Options", "allow").set("X-XSS-Protection", "1, mode=block");
  // headers = {
  //   "X-Frame-Options":"deny",
  //   "X-XSS-Protection":"1, mode=block"
  //   }
  get(url: string, headers={}): Observable<any> {
    return this.http.get(url, {
      headers,
    });
  }

  post(url: string, body:any, headers={}): Observable<any> {
    return this.http.post(url, body, {headers});
  }

  put(url: string, data: any): Observable<any> {
    return this.http.put(url, data);
  }

  delete(url: string): Observable<any> {
    return this.http.delete(url);
  }
}
